<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize
      }"
      row-id="materialCode"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.materialStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.v_materialStatus }}
        </el-tag>
      </template>
      <template v-slot:displayCreateByName="{ row }">
        <span>{{ row.createByName }}</span>
        <br />
        <span>{{ row.createDate }}</span>
      </template>      
      <template v-slot:materialCategory="{ row }">
        <span>{{ row.mainMaterialCategoryName }} / {{ row.detailMaterialCategoryName }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { materialCode: row.materialCode }
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-show="row.materialStatus === 'Y'"
            v-if="allow('M')"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: {
                    materialCode: row.materialCode,
                    productLine: row.materialCode
                  }
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-show="row.materialStatus === 'Y'"
            v-if="allow('D')"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.materialCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_copy') || '复制'"
            placement="top"
            v-show="row.materialStatus === 'Y'"
            v-if="allow('C')"
          >
            <i
              class="el-icon-document-copy tool-btn"
              @click="copy(row.materialCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:defaultImageUrl="{ row }">
        <el-image
          :src="
            row.defaultImageUrl
              ? $osscdn(row.defaultImageUrl)
              : '/image/static/img/nopic.jpg'
          "
          style="width:100px; height:66px"
        >
          <div slot="error" class="image-slot">
            <img
              src="/image/static/img/nopic.jpg"
              style="width: 100px; height: 66px"
            />
          </div>
        </el-image>
      </template>
      <template v-slot:materialNameInfo="{ row }">
        <span>{{ row.materialNo }}</span>
        <br />
        <span>{{ row.materialName }}</span>
        <br />
        <span>{{ row.materialNameEn }}</span>
      </template>
      <template v-slot:displayName="{ row }">
        <span>{{ row.displayName }}</span>
        <br />
        <span>{{ row.displayNameEn }}</span>
      </template>
      <template v-slot:moqInfo="{ row }">
        {{ row.moq }} {{ row.moqUnit }}
      </template>
      <template v-slot:priceInfo="{ row }">
        {{ row.price }} {{ row.v_currencyUnit }}
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">
            {{ $l('INDEX.table_label_no_data') || '暂无数据！' }}
          </p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight, EditLoading],
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    tablePage: {
      default: null,
      type: Object
    },
    loading: {
      default: false
    }
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form'
        },
        refresh: {
          query: () => this.$emit('reload')
        },
        zoom: true,
        custom: true
      },
      tableColumns: tableColumns(this)
    }
  },
  methods: {
    del(materialCode) {
      this.$confirm(
        this.$l('INDEX.tips_delete') || '是否要删除该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      ).then(() => {
        this.$api.materialInfoDelApi({ materialCode }).then(() => {
          this.$message({
            showClose: true,
            message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
            type: 'success'
          })
          this.$emit('reload')
        })
      })
    },
    async copy(materialCode) {
      const confirm = await this.$confirm(
        this.$l('tips_copy') || '是否要复制该记录？',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning'
        }
      )
        .then(() => true)
        .catch(() => false)
      if (!confirm) return
      if (this.loadingOpen()) return

      const res = await this.$api
        .materialInfoCopyApi({ materialCode })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
        type: 'success'
      })
      this.openEditPage({
        pageType: 'edit',
        params: { materialCode: res.body }
      })
    },
    openEditPage({ pageType, params = {} }) {
      this.$router.push({
        name: 'material-materialInfoSet-detail',
        params: { ...params, pageType }
      })
    }
  }
}
</script>
